;(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const splides = document.querySelectorAll('.value-props-bar .splide')

    splides.forEach((splide) =>
      new Splide(splide, {
        type: 'loop',
        autoplay: true,
        perPage: 2,
        arrows: false,
        pagination: false,
        easing: 'linear',
        gap: 24,
        interval: 5000,
        speed: 5000,
        mediaQuery: 'min',
        breakpoints: {
          768: {
            destroy: true,
          },
        },
      }).mount()
    )
  })
})()
